import React, { useState } from 'react';
import { 
    GridItem,
    VStack, Flex, Heading,
    Menu,
    MenuButton,
    MenuItem,
    HStack,
    Text,
    Button,
    MenuList,
    Box,
} from '@chakra-ui/react';

import QuestionCard from "./QuestionCard.js"
import { AddOutlined, ExpandMore, FilterList } from '@mui/icons-material';
import { IconButton } from '@mui/material';

const BottomRight = ({
  formData, 
  selectedTab, 
  selectedSection, 
  setFormData, 
  setUpdatedData, 
  scrollToQuestionCard, 
  setScrollToQuestionCard,
  allCollaborators,
  selectedFilter, setSelectedFilter,
  setIsEntityChatOpen,
  setEntityChatData,
  createRef,
  setSelectedRefId,
  selectedConversationTab,
  setSelectedConversationTab,
}) => {
    const updateQuestionData = ({index, data}) => {
        let sections = []
        let sectionData = {}
        for (let i = 0; i < formData?.sections?.length; i++) {
            if (formData?.sections[i].index == selectedSection) {
                sectionData = formData?.sections[i]
                if (selectedTab == "fill") {
                    let fillData = []
                    for (let j = 0; j < formData?.sections[i].fill_response.length; j++) {
                        if (j == index) {
                            fillData.push(data)
                        } else {
                            fillData.push(formData?.sections[i].fill_response[j])
                        }
                    }
                    sectionData.fill_response = fillData
                }
                else {
                    let reviewData = []
                    for (let j = 0; j < formData?.sections[i].review_response.length; j++) {
                        if (j == index) {
                            reviewData.push(data)
                        } else {
                            reviewData.push(formData?.sections[i].review_response[j])
                        }
                    }
                    sectionData.review_response = reviewData
                }
                sections.push(sectionData)
            } else {
                sections.push(formData?.sections[i])
            }
        }

        setFormData((prevData) => ({
            ...prevData,
            sections: sections,
        }))
    }

    const ContentData = () => {
      let sectionData = []
      let section = {}
      for (let i = 0; i < formData?.sections?.length; i ++) {
        console.log("[Form] section data is",formData?.sections[i])
        if (formData?.sections[i].index == selectedSection) {
          section = formData?.sections[i]
          if (selectedTab == "fill") {
            sectionData = formData?.sections[i].fill_response
          }
          else {
            sectionData = formData?.sections[i].review_response
          }
        }
      }

      const numberOfQuestionCards = () => {
        let count = 0;
        for (let i = 0; i < sectionData?.length; i++) {
          if (selectedFilter == "unfilled" && sectionData[i].state != "unfilled") {
            continue
          } else if (selectedFilter == "unreviewed" && sectionData[i].state != "unapproved") {
            continue
          } else if (selectedFilter == "completed" && sectionData[i].state != "approved") {
            continue
          }

          count++
        }

        return count
      }

      if (formData == undefined || formData == null) {
        return (
          <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              height="50%"
          >
              <Text fontSize="2xl" fontWeight="bold">Loading...</Text>
          </Box>
        )
      }

      console.log("[Form] sections are",sectionData)
      return (
        numberOfQuestionCards() == 0 ? (
          <Text marginTop={"80px"} fontSize={"20px"}>
            { selectedFilter == "unfilled" ? "No questions here need your input" : 
              selectedFilter == "unreviewed" ? "No questions here need your review" : 
              selectedFilter == "completed" ? "None of the questions here are completed" : 
              "No questions available"
            }
          </Text>
        ): (
          <>
            <BottomRightHeading sectionData={section} filterType={selectedFilter} setFilterType={setSelectedFilter} selectedTab={selectedTab} isCollaborator={formData?.is_collaborator}/>
            {sectionData?.sort((a,b) => a.display_order - b.display_order).map((data, i) =>{ 
              const newRefId = selectedSection + "-" + i
              const newRef = createRef(newRefId)
              return (
                <QuestionCard 
                  questionData={data}
                  updateQuestionData={updateQuestionData}
                  updateQuestionIndex={i}
                  setUpdatedData={setUpdatedData}
                  scrollToQuestionCard={scrollToQuestionCard}
                  setScrollToQuestionCard={setScrollToQuestionCard}
                  filterType={selectedFilter}
                  allCollaborators={allCollaborators}
                  isCollaborator={formData.is_collaborator}
                  setIsEntityChatOpen={setIsEntityChatOpen}
                  setEntityChatData={setEntityChatData}
                  ref={newRef}
                  refId={newRefId}
                  setSelectedRefId={setSelectedRefId}
                  selectedConversationTab={selectedConversationTab}
                  setSelectedConversationTab={setSelectedConversationTab}
                />
            )})}
          </>
        )
      )
    }
  
    return (
      <GridItem 
        area="pagecontent"
        bg="#FFFFFF"
        p={0} 
        overflowY="auto"
        height="99%"
        placeItems="center"
        alignSelf="start"
        maxWidth={"100%"}
        data-scrollable="true"
      >
        <VStack align="center" spacing={0} width={"100%"}>
          <ContentData/>
        </VStack>
      </GridItem>
    )
  }
  
  const BottomRightHeading = ({sectionData, filterType, setFilterType, selectedTab, isCollaborator}) => {
    function getUnfilledAnswers() {
      console.log("[Form][BottomLeft] section data is", sectionData)
      let count = 0;
      if (selectedTab == "fill") {
        for (let i = 0; i < sectionData.fill_response?.length; i++) {
          if (sectionData.fill_response[i].state == "unfilled") {
            count++
          }
        }
      }
  
      if (selectedTab == "review") {
        for (let i = 0; i < sectionData.review_response?.length; i++) {
          if (sectionData.review_response[i].state == "unfilled") {
            count++
          }
        }
      }
  
      return count
    }
  
    function getUnreviewedAnswers() {
      let count = 0;
      if (selectedTab == "fill") {
        for (let i = 0; i < sectionData.fill_response?.length; i++) {
          if (sectionData.fill_response[i].state == "unapproved") {
            count++
          }
        }
      }
  
      if (selectedTab == "review") {
        for (let i = 0; i < sectionData.review_response?.length; i++) {
          if (sectionData.review_response[i].state == "unapproved") {
            count++
          }
        }
      }
  
      return count
    }
  
    function getCompletedAnswers() {
      console.log("[Form][BottomLeft] section data is", sectionData)
      let count = 0;
      if (selectedTab == "fill") {
        for (let i = 0; i < sectionData.fill_response?.length; i++) {
          if (sectionData.fill_response[i].state == "approved") {
            count++
          }
        }
      }
  
      if (selectedTab == "review") {
        for (let i = 0; i < sectionData.review_response?.length; i++) {
          if (sectionData.review_response[i].state == "approved") {
            count++
          }
        }
      }
  
      return count
    }

    const getFilterText = (filterType) => {
      switch (filterType) {
        case 'unfilled':
          return 'Needs input';
        case 'unreviewed':
          return 'Needs review';
        case 'completed':
          return 'Completed';
        default:
          return 'All questions';
      }
    }

    return (
      <Flex justifyContent="space-between" alignItems="center"
        // borderBottomWidth="2px" 
        // borderBottomColor="blue.500" 
        padding="8px" 
        width="100%"
        top="0"
        zIndex="10"
        bg="#FFFFFF"
        paddingX={"10%"}
        marginTop="16px"
      >
        <Text justify={"flex-start"} fontSize={"24px"} margin={0} fontWeight={"semibold"} color={"#1d1d1d"}>{sectionData.section_name}</Text>

        {
          true && sectionData?.section_name && (
            <Menu placement="bottom" justify={"flex-end"} offset={[0, 0]}>
              <MenuButton 
                as={Button} 
                bg="white" 
                border={"1px"}
                borderColor={"#E5E5E5"} 
                borderRadius={"40px"} 
                height={"32px"} 
                justifyContent={"center"} 
                alignContent={"center"} 
                paddingX={"16px"}
                _active={{ bg: "transparent" }}
                _focus={{ bg: "transparent" }}
                _hover={{
                  // backgroundColor: 'blue.500',  // Change background on hover
                  // color: '#2584fd',  // Change text color on hover
                  // borderColor: "#adadad",
                  border: "1px solid #adadad",
                }}
              >
                <HStack height="16px" alignItems="center" gap="2px">
                  <IconButton
                    sx={{ padding: 0, marginX: "2px", fontSize: "16px", color: "#5D5D5D", height: "16px", width: "16px" }}
                  >
                    <FilterList sx={{ padding: 0, fontSize: "16px" }}/>
                  </IconButton>
                  <Text
                    color="#1d1d1d" 
                    fontSize="13px" 
                    lineHeight="16px"
                    fontWeight={"400"} 
                    marginLeft={"2px"}
                    alignSelf="flex-start"
                    fontFamily={"'Inter', sans-serif"}
                  >
                    Filter by
                  </Text>
                  <Text
                    marginLeft={"6px"}
                    color="#2584FD" 
                    fontSize="13px" 
                    lineHeight="16px"
                    fontWeight={"400"} 
                    alignSelf="flex-start"
                    fontFamily={"'Inter', sans-serif"}
                  >
                    {getFilterText(filterType)}
                  </Text>
                </HStack>
              </MenuButton>
              <MenuList minW="unset" width={"162px"}>
                <MenuItem color={"#1d1d1d"} fontFamily={"sans-serif"} fontWeight={"400"} fontSize={"13px"} onClick={() => setFilterType('all')}>
                  All questions
                </MenuItem>
                {getUnfilledAnswers() > 0 && (
                  <MenuItem color={"#1d1d1d"} fontFamily={"sans-serif"} fontWeight={"400"} fontSize={"13px"} onClick={() => setFilterType('unfilled')}>
                    Needs input
                  </MenuItem>
                )}
                {getUnreviewedAnswers() > 0 && (
                  <MenuItem color={"#1d1d1d"} fontFamily={"sans-serif"} fontWeight={"400"} fontSize={"13px"} onClick={() => setFilterType('unreviewed')}>
                      Needs review
                  </MenuItem>
                )}
                {getCompletedAnswers() > 0 && (
                  <MenuItem color={"#1d1d1d"} fontFamily={"sans-serif"} fontWeight={"400"} fontSize={"13px"} onClick={() => setFilterType('completed')}>
                      Completed
                  </MenuItem>
                )}
              </MenuList>
            </Menu>
          )
        }
      </Flex>
    )
  }

export default BottomRight;